import { AttachedContext } from '../AttachedContext';
export class ConditionEvaluatorContext extends AttachedContext {
    evaluator;
    constructor(evaluator, overwrites) {
        super(evaluator.attachedTrait);
        this.evaluator = evaluator;
    }
    get condition() {
        return this.evaluator.traitCondition;
    }
    get parentContext() {
        return this.evaluator.parent.context;
    }
    get modifiedAspect() {
        if (!this.condition || !this.condition.reg.modifyContext)
            return undefined;
        const modifier = this.condition.reg.modifyContext;
        if (modifier && modifier.aspect) {
            return modifier.aspect(this);
        }
        return undefined;
    }
    get modifiedActor() {
        if (!this.condition || !this.condition.reg.modifyContext)
            return undefined;
        const modifier = this.condition.reg.modifyContext;
        if (modifier && modifier.actor) {
            return modifier.actor(this);
        }
        return undefined;
    }
    get leftChildEvaluator() {
        return this.evaluator.evaluator_left;
    }
    get rightChildEvaluator() {
        return this.evaluator.evaluator_right;
    }
}
